var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tabs),function(tab){return _c('menu-item',{key:tab.id,attrs:{"item":tab}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }